// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"2653d6bc","335":"7548cbab","336":"bd2c42f2","394":"9de18dbb","692":"331fd49f","725":"fcd3903e","760":"daaee479"}[chunkId] + ".js";
};